<template>
    <svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.5 6C12.5 2.68629 9.81371 0 6.5 0C3.18629 0 0.5 2.68629 0.5 6C0.5 8.99477 2.69411 11.477 5.5625 11.9271V7.73438H4.03907V6H5.5625V4.67813C5.5625 3.17437 6.45826 2.34375 7.82879 2.34375C8.48524 2.34375 9.17188 2.46094 9.17188 2.46094V3.9375H8.41529C7.66994 3.9375 7.43751 4.40001 7.43751 4.8745V6H9.10157L8.83555 7.73438H7.4375V11.9271C10.3059 11.477 12.5 8.99477 12.5 6Z"
            fill="#1877F2"
        />
        <path
            d="M8.83555 7.73437L9.10156 6H7.4375V4.87449C7.4375 4.4 7.66994 3.9375 8.41529 3.9375H9.17188V2.46093C9.17188 2.46093 8.48524 2.34375 7.82879 2.34375C6.45825 2.34375 5.5625 3.17437 5.5625 4.67813V6H4.03906V7.73437H5.5625V11.9271C5.87263 11.9757 6.18608 12.0001 6.5 12C6.81894 12 7.13202 11.975 7.4375 11.9271V7.73437H8.83555Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
    name: "FacebookLogo",
};
</script>
